
var React = require("react");
var ApplicationContext = require("../../shared/config/ApplicationContext.js");
var Application = require("../Application.js");
const {  Link  } = require('react-router-dom');

var Q = require("q");

class Logins extends React.Component {

    constructor(){
        super();

        this.doAuth = this.doAuth.bind(this);
    }

    componentWillMount(){
        this.urlSignUp = `${ApplicationContext.adskAccountUrl}/register`;
    }
    /**
     * This method will only be called on client side
     */
    componentDidMount() {
        var user = ApplicationContext.getUserData();
        var url = ApplicationContext.getAdskAccountUrl();

        if (user) {
            this.fillUser(user, url);
        } else {
            Application.dataStore.getUserInfo(this.props.handleError).then((succeed) => {
                if (succeed) {
                    this.fillUser(ApplicationContext.getUserData(), url);
                } else {
                    if (this.props.loginRequired) {
                        this.doAuth();
                    }
                }
            });
        }
    }

    doAuth(){
        Application.dataStore.doAuth();
        this.props.onSendGoogleGA("home", "signin");
    }

    fillUser(user, url){
        this.profileLink = `${url}/users/${user.id}/view`;
        this.setState({ user });
    }

    render() {

        var userSection = undefined;
        if (this.state && this.state.user) {
            // User has login
            userSection = (
                <div className="header__buttons">
                    <Link to="/start" className="header__buttons__user">
                        {ApplicationContext.getUserData().name}
                    </Link>
                    <Link to="/start">
                        <img src={ApplicationContext.getUserData().avatar} />
                    </Link>
                </div>

            );
        } else {
            // need to show login ui
            userSection = (
                <div className="header__buttons">
                    <a className="header__buttons__signIn button" href="#" onClick={this.doAuth} >Sign In</a>
                    <a className="header__buttons__signUp button" href={this.urlSignUp} onClick={() => this.props.onSendGoogleGA("home", "signUp")} target="_blank" >Sign Up</a>
                </div>
            );

        }

        return (
            userSection
        );
    }
}

module.exports = Logins;
